


















































































































import { Component, Vue } from 'vue-property-decorator'

import { mdiCircleSmall } from '@mdi/js'

import { security } from '@/store/modules/security'

import { settings } from '@/store/modules/settings'
import { mock } from '@/tools'

export interface TransportList {
  title: string
  list: Array<string>
}

@Component
class TransportView extends Vue {
  securityModule = security.context(this.$store)
  settingsModule = settings.context(this.$store)

  icons = {
    mdiCircleSmall,
  }

  get titleStyle() {
    return this.$vuetify.breakpoint.mdAndDown || this.$theme.isSpecial ? 'pl-0' : undefined
  }

  get showReplenishBlock() {
    return this.securityModule.state.userTransport.status === 'Активирован'
  }

  cardsLists: TransportList[] = [
    {
      title: 'Карта "Школьная"',
      list: [
        'Свидетельство о рождении (для детей до 14 лет);',
        'Паспорт РФ (для подростков старше 14 лет);',
        'Справка из учебного заведения (на текущий учебный год).',
      ],
    },
    {
      title: 'Карта "Студенческая"',
      list: ['Паспорт РФ;', 'Студенческий билет (для первокурсников - Справка о зачислении в учебное заведение).'],
    },
    {
      title: 'Карта "Забота"*',
      list: [
        'Паспорт РФ;',
        'Свидетельство о рождении (для детей);',
        'Документ, подтверждающий льготу (Удостоверение многодетной семьи; Удостоверение почетного донора России; Удостоверение участника боевых действий; Справка по инвалидности; Удостоверение Чернобыльца).',
      ],
    },
  ]

  categoriesList: TransportList = {
    title: '*Карта действует для следующих категорий населения:',
    list: [
      'Граждане, достигшие возраста: 55 лет (женщины) и 60 лет (мужчины);',
      'Инвалиды;',
      'Многодетные семьи;',
      'Ветераны боевых действий;',
      'Почетные доноры России;',
      'Категории граждан, подвергшихся воздействию радиации вследствие Чернобыльской катастрофы.',
    ],
  }

  async created() {
    await this.securityModule.actions.getUserTransport().catch(mock)
  }
}

export default TransportView
